import { shallowMount } from "@vue/test-utils";
import GraciasCA from "@/views/GraciasCA";

describe("GraciasCA component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(GraciasCA);
  });

  it("Renders del component GraciasCA", () => {
    expect(wrapper).toBeDefined();
  });
});
